var cov_1yp9mcfshr = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/styles/index.ts",
      hash = "9e4772e681ab7552a6de8e640ae5cec0eb16cdcc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var imageLess = {};
import genaration from '../../utils/classname';
export var imageClass = (cov_1yp9mcfshr.s[0]++, genaration(imageLess, 'image'));